<template>
    <div class="p-4 bg-white shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center mb-4">
            <span class="text-2xl mr-2">📉</span>
            <span>Programs with Higher Attrition Rates</span>
        </h2>

        <!-- Admission Year Filter -->
        <div class="">
            <label class="text-sm font-medium text-gray-700 mr-2">Admission Year:</label>
            <select v-model="selectedYear" class="border outline-none text-sm px-2 py-1">
                <option value="">All</option>
                <option v-for="year in admissionYears" :key="year" :value="year">{{ year }}</option>
            </select>
        </div>

        <div v-if="hasData">
            <apexchart type="bar" height="700" :options="chartOptions" :series="series" />
        </div>

        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">⚠️</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgramsWithHigherAttritionOrDropoutRates",
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        clearInnerFilters: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedYear: "",
            admissionYears: [
                "2015-2016",
                "2016-2017",
                "2017-2018",
                "2018-2019",
                "2019-2020",
                "2020-2021",
                "2021-2022",
                "2022-2023",
                "2023-2024",
                "2024-2025",
            ],
        };
    },
    watch: {
        selectedYear(newVal) {
            this.$emit('fetch-data', newVal);
        },
        clearInnerFilters(newVal) {
            if (newVal) {
                this.selectedYear = "";
            }
        },
    },
    computed: {
        hasData() {
            return Array.isArray(this.data) && this.data.length > 0;
        },
        series() {
            return [
                {
                    name: "Attrition Rate",
                    data: this.sortedData.map(d => d.attrition_rate),
                }
            ];
        },
        sortedData() {
            // Sort descending by attrition_rate
            return [...this.data].sort((a, b) => b.attrition_rate - a.attrition_rate);
        },
        chartOptions() {
            return {
                chart: {
                    type: "bar",
                    stacked: false,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: "50%",
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: val => `${val}%`,
                    style: {
                        fontSize: '12px',
                        fontWeight: '600',
                        colors: ['#000000']
                    },
                },
                xaxis: {
                    categories: this.sortedData.map(d => d.program_name),
                    labels: { formatter: val => `${val}%` },
                },
                yaxis: {
                    title: { text: "Attrition Rate (%)" },
                    max: 100,
                },
                colors: [
                    "#01B8AA", "#374649", "#FD625E", "#F2C80F", "#5F6B6D",
                    "#8AD4EB", "#FE9666", "#A66999", "#3599B8", "#DFBFBF",
                    "#60BD68", // fresh green, balanced saturation
                    "#B2912F", // muted golden brown
                    "#B276B2", // soft purple, works with #A66999
                    "#F17CB0", // pink accent, not too bright
                    "#E15759", // deep red variant, less saturated than #FD625E
                    "#72B7B2"  // teal variant, complements #01B8AA
                ],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'horizontal', // horizontal for horizontal bars
                        shadeIntensity: 0.5,
                        gradientToColors: undefined, // can also set array for per-bar gradient
                        inverseColors: false,
                        opacityFrom: 0.85,
                        opacityTo: 0.85,
                        stops: [0, 100]
                    }
                },
                tooltip: {
                    y: {
                        formatter: val => `${val}%`,
                    },
                },
                legend: {
                    show: true,
                    position: "right",
                    formatter: function (val, opts) {
                        return val + " - " + opts.w.globals.series[0][opts.seriesIndex] + "%";
                    }
                },
                responsive: [
                    {
                        breakpoint: 1024,
                        options: {
                            legend: {
                                position: 'bottom',
                            }
                        }
                    },
                    {
                        breakpoint: 640,
                        options: {
                            legend: {
                                show: false,
                            }
                        }
                    },
                ],
            };
        }
    }
};
</script>